import APP_ROUTES from "app/constants/routes/app";
import { getQueryParams } from "app/hooks/useCustomNavigation";
import { getItem, setItem } from "app/utils/session";
import { Redirect, Route } from "react-router";

const PrivateRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = getItem("token");

    if (!isAuthenticated && getQueryParams('jobId')) {
        setItem("jobRedirection", `${window.location.pathname}${window.location.search}`);
    }

    return (
        <Route
            {...rest}
            render={(props) => (
                isAuthenticated
                    ? <Component {...props} />
                    : <Redirect to={APP_ROUTES.LOGIN} />
            )}
        />
    );
};

export const PublicRoute = ({ component: Component, restricted = false, ...rest }) => {
    const isAuthenticated = getItem("token");

    return (
        <Route
            {...rest}
            render={(props) => (
                isAuthenticated && restricted
                    ? <Redirect to={APP_ROUTES.HOME} />
                    : <Component {...props} />
            )}
        />
    );
};

export default PrivateRoute;
